import React, { useMemo, useEffect, useState } from "react";
import ReactDOM from "react-dom";

export const KinohodWidget = ({ seance, onClose }) => {
    const referrer = typeof window !== "undefined" ? window.location.host : "";

    const __html = useMemo(() => {
        const src = `//kinohod.ru/widget/seances/${seance}?apikey=017abbb3-7f77-33e2-813b-098f4a8a564e&type=seance&_referrer=${encodeURIComponent(
            referrer
        )}&__referrer=boxoffice`;

        return `
      
        <div class="">
          <div class="" id="khBoxOfficeBackward" style="height: 963px; left: 0px; width: calc(50% - 320px);"></div>
          <div class="" id="khBoxOfficeCollapse" style="height: 963px; right: 0px; width: calc(50% - 320px);"></div>
          <div class="" id="khBoxOfficeFrame" style="max-width: 640px; left: calc(50% - 7.5px); margin-left: -320px;">
            <div class="khBoxOfficeBtnIcon khBoxOfficeBtnIconBackward" style="left: -40px;"></div>
            <div class="khBoxOfficeBtnIcon khBoxOfficeBtnIconCollapse" style="right: -20px;"></div>
            <iframe
              class=""
              id="widgetFrame"
              name="widgetFrame"
              src="${src}"
              frameborder="0"
              scrolling="yes"
              style="max-width: 640px;">
            </iframe>
          </div>
        </div>
      
    `;
    }, [seance, referrer]);

    useEffect(() => {
        const timeout = setTimeout(() => {
            const closeBtn = document.querySelector(".khBoxOfficeBtnIconCollapse");
            if (closeBtn) {
                closeBtn.addEventListener("click", onClose);
            }
        }, 0);

        return () => {
            clearTimeout(timeout);
            const closeBtn = document.querySelector(".khBoxOfficeBtnIconCollapse");
            if (closeBtn) {
                closeBtn.removeEventListener("click", onClose);
            }
        };
    }, [onClose]);

    return <div id={'khBoxOfficeOverlay'} dangerouslySetInnerHTML={{ __html }} />;
};

export const KinohodPortal = ({ seance, onClose }) => {
    const [holder, setHolder] = useState(null);

    useEffect(() => {
        const target = document.getElementById("khBoxOfficeHolder");
        if (target) {
            setHolder(target);
        }
    }, []);

    if (!holder) return null;

    return ReactDOM.createPortal(
        <KinohodWidget seance={seance} onClose={onClose} />,
        holder
    );
};